import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { Configuration } from 'remarketing-angular-library';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { TranslocoDirective } from '@jsverse/transloco';
import { ErrorIconComponent } from 'remarketing-ui-components-lib';


@Component({
    selector: 'app-action-list-error-modal',
    templateUrl: './action-list-error-modal.component.html',
    styleUrls: ['./action-list-error-modal.component.scss'],
    imports: [TranslocoDirective, ErrorIconComponent]
})
export class ActionListErrorModalComponent implements OnInit {
  private readonly _destroy$ = new Subject();

  configuration: Configuration;

  @Input()
  errorMessage: string;

  @Output()
  close = new EventEmitter();

  @Output()
  error = new EventEmitter<string>();

  constructor(private readonly store: Store) {}

  ngOnInit(): void {
    this.store
      .select(state => state.configuration.configuration)
      .pipe(takeUntil(this._destroy$))
      .subscribe(configuration => (this.configuration = configuration));
  }

  closeModal() {
    this.close.emit();
  }
}
